export const ERROR_CODES = {
  forbidden: 403,
};
